// Maori translations
export const mi: Record<string, string> = {
  'menu.dashboard': 'Papa Whakahaere',
  'menu.customers': 'Kaihoko',
  'menu.products': 'Hua',
  'menu.users': 'Kaiwhakamahi',
  'menu.settings': 'Tautuhinga',
  'menu.logout': 'Takiputa',
  'dashboard.title': 'Papa Whakahaere',
  'dashboard.newOrder': 'Ōtā Hou',
  'order.title': 'Ōtā Hou',
  'order.customer': 'Kaihoko',
  'order.products': 'Hua',
  'order.total': 'Tapeke',
  'users.title': 'Kaiwhakamahi',
  'users.name': 'Ingoa',
  'users.email': 'Īmēra',
  'common.yes': 'Āe',
  'common.no': 'Kāo',
  'common.cancel': 'Whakakore',
  'common.save': 'Tiaki',
  'common.search': 'Rapu',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Takiuru',
  'login.welcome': 'Nau mai, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Īmēra',
  'signup.phone': 'Waea',
  'menu.reportsAndAccounting': 'Ngā Pūrongo me te Kaute',
  'menu.systemAndCommunication': 'Pūnaha me te Whakawhitiwhiti',
};